import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Field } from 'react-formality'
import { TextField } from '@material-ui/core'

import connectPropTypes from './utilities/connectPropTypes'
import handlerToCallUpdateIfValid from './utilities/Data/handlerToCallUpdateIfValid'
import getField from './utilities/Data/getField'
import Form from './components/Form'
import getFieldValueInUnit from './utilities/Data/User/getFieldValueInUnit'
import Img from './components/Img'
import DistanceUnitField from './components/Edit/DistanceUnitField'

import editStyles from './Edit.icss'

class EditHeight extends React.Component {
	constructor(props) {
		super(props)

		this.handlerToCallStatisticsUpdateIfValid = handlerToCallUpdateIfValid(props.userProfileStatisticsUpdate, { history: props.history })
		this.form = React.createRef()
		this.inputRef = React.createRef()
		this.scrollTimeout = null

		props.appShowBottomBar(false)
		props.appShowBottomNavBar(true)
		props.appBottomNavBarHandleClick(() => this.form.current.submit())
	}

	componentDidMount() {
		this.props.appHeading({ text: this.context.translate('Height measurement') })
		this.props.appBottomNavBarLabelNext(this.context.translate('Done'))
	}

	render() {
		if (!this.props.user.userProfile) {
			return null
		}

		const statistics = getField(this.props.user, 'userProfile.statistics')

		return (
			<section>
				<div className={editStyles.pagePadding}>
					<Form
						ref={this.form}
						onSubmit={({ values, isValid }) => isValid && this.props.userProfileStatisticsUpdate({ values, goBack: true, history: this.props.history })}
						className={classNames(editStyles.oneColumn)}
						initialValues={{
							height: getFieldValueInUnit(statistics, 'height') || '',
							heightUnit: getField(statistics, 'height.unit') || 'cm'
						}}
					>
						{(props) => {
							if (props.isValid === false) {
								this.inputRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' })
							}
							const handlerToCallStatisticsUpdateIfValid = this.handlerToCallStatisticsUpdateIfValid(props.store)
							return (
								<React.Fragment>
									<h2>{this.context.translate('Measure your height')}</h2>
									<Img content="/images/content/guide/height.svg" className={editStyles.img} />
									<p>
										{this.context.translate('Stand against a wall in socks or bare feet and measure from the top of your head to the floor. Ask a friend to mark the top of your head on the wall with masking tape or a hand.')}
									</p>
									<div className={editStyles.statistic}>
										<Field
											component={TextField}
											inputRef={this.inputRef}
											name="height"
											className={editStyles.statisticValue}
											placeholder={props.values.heightUnit}
											label={this.context.translate('Height')}
											value={props.values.height}
											type="number"
											onBlur={handlerToCallStatisticsUpdateIfValid('height', 'heightUnit')}
											validate={{
												presence: true,
												numericality: true
											}}
										/>
										<DistanceUnitField
											name="heightUnit"
											value={props.values.heightUnit}
											onBlur={handlerToCallStatisticsUpdateIfValid('heightUnit', 'height')}
											onChange={props.store.setBinder('heightUnit')}
										/>
									</div>

								</React.Fragment>
							)
						}}
					</Form>
				</div>
			</section>
		)
	}
}

EditHeight.contextTypes = {
	translate: PropTypes.func
}

EditHeight.propTypes = {
	user: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	appBottomNavBarHandleClick: PropTypes.func.isRequired,
	appBottomNavBarLabelNext: PropTypes.func.isRequired,
	appHeading: PropTypes.func.isRequired,
	appShowBottomBar: PropTypes.func.isRequired,
	appShowBottomNavBar: PropTypes.func.isRequired,
	userProfileStatisticsUpdate: PropTypes.func.isRequired,
	history: PropTypes.shape({
		goBack: PropTypes.func.isRequired
	}).isRequired
}

export default connectPropTypes(EditHeight)



// WEBPACK FOOTER //
// ./src/EditHeight.jsx